import type { RouteRecordRaw } from 'vue-router'

export const notificationRoutes: RouteRecordRaw[] = [
  {
    path: '/notifications',
    children: [
      {
        path: '',
        name: 'Notifications',
        component: () => import('@/modules/notifications/views/NotificationsListScreen.vue'),
        meta: { requiresAuth: true },
      },
    ],
  },
]